import i18n from '../locales';
import axios from 'axios';
import store from '../store';
import preassignmentEnUS from '../locales/en-US/preassignment.json';
import preassignmentEsCL from '../locales/es-CL/preassignment.json';
import preassignmentEsMX from '../locales/es-MX/preassignment.json';
import preassignmentEsCO from '../locales/es-CO/preassignment.json';
export default {
  name: 'AssignVehicleForm',
  props: ['driver', 'vehicles', 'callback'],
  data() {
    return {
      baseItems: [],
      clientFilter: null,
      groupFilter: null,
      typeFilter: null,
      isBusy: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
      sortBy: '',
      sortDesc: false,
      selectedVehicle: null,
      errorMessage: '',
      dismissCountDown: 0,
      dismissSecs: 5,
      highlightedRow: null,
      launched: false,
      options: {
        clientList: [],
        groupList: [],
        typeList: [],
      },
    };
  },
  async created() {
    await this.prepareData();
  },
  computed: {
    rows() {
      return this.baseItems.length;
    },
    items() {
      return this.vehicles.map((v) => {
        return {
          id: v.id,
          plate: v.plate,
          client: v.client.name,
          type: v.vehicleType.description,
          group: v.group.name,
          selected: this.driver.vehicles.map((a) => a.id).includes(v.id),
        };
      });
    },
    fields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
        sortable: true,
      };
      return [
        {
          key: 'id',
          label: '',

          ...common,
          sortable: false,
        },
        {
          key: 'plate',
          label: this.t('preassignment.formulario.tabla.cabeceras.patente'),
          ...common,
        },
        {
          key: 'client',
          label: this.t('preassignment.formulario.tabla.cabeceras.empresa'),
          ...common,
        },
        {
          key: 'group',
          label: this.t('preassignment.formulario.tabla.cabeceras.grupo'),
          ...common,
        },
        {
          key: 'type',
          label: this.t('preassignment.formulario.tabla.cabeceras.tipo'),
          ...common,
        },
      ];
    },
  },
  methods: {
    filteredItems() {
      let filterItems = this.items;
      if (this.clientFilter !== null) {
        filterItems = filterItems.filter((i) => i.client === this.clientFilter);
      }
      if (this.groupFilter !== null) {
        filterItems = filterItems.filter((i) => i.group === this.groupFilter);
      }
      if (this.typeFilter !== null) {
        filterItems = filterItems.filter((i) => i.type === this.typeFilter);
      }
      this.baseItems = filterItems;
      console.log('owo', this.baseItems);
      return this.baseItems;
    },
    prepareData() {
      this.filteredItems();
      this.populateClientFilter(); //Carga lista de empresas de los vehículos activos.
      this.populateGroupFilter(); //Carga lista de grupos de los vehículos activos.
      this.populateTypeFilter(); //Carga lista de tipos de vehículos de los vehículos activos.
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de empresas para el filtro.
     */
    populateClientFilter() {
      //Obtiene todos las empresas de los vehículos que lo posean.
      this.vehicles.forEach((vehicle) => {
        this.options.clientList.push(vehicle.client.name);
      });
      //Remueve elementos repetidos del resultado.
      this.options.clientList = this.options.clientList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de grupos de vehículos para el filtro.
     */
    populateGroupFilter() {
      //Obtiene todos los grupos de los vehículos que lo posean.
      this.vehicles.forEach((vehicle) => {
        this.options.groupList.push(vehicle.group.name);
      });
      //Remueve elementos repetidos del resultado.
      this.options.groupList = this.options.groupList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que popula la lista de tipos de vehículos para el filtro.
     */
    populateTypeFilter() {
      //Obtiene todos los tipos de los vehículos que lo posean.
      this.vehicles.forEach((vehicle) => {
        this.options.typeList.push(vehicle.vehicleType.description);
      });
      //Remueve elementos repetidos del resultado.
      this.options.typeList = this.options.typeList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },
    t(key) {
      return i18n.t(key);
    },
    async confirm() {
      this.launched = true;
      this.highlightedRow = null;
      this.clientFilter = '';
      this.groupFilter = '';
      this.typeFilter = '';
      if (this.selectedVehicle) {
        const url = `${store.getters.urlAPI}/driverVehicle/${this.driver.id}/vehicle`;
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        try {
          await axios.put(url, [this.selectedVehicle], config);
          if (this.callback) {
            this.callback([this.selectedVehicle]);
          }
          this.$bvModal.hide('assign-vehicle-form-modal');
        } catch (e) {
          this.launched = false;
          if (e.response) {
            document.getElementById('assign-vehicle-form-modal___BV_modal_body_').scrollTop = 0;
            const rawResponse = e.response.data;
            const cuting = rawResponse.split('id_vehicle)=(')[1].split(') already exists')[0];
            const idVehicle = !isNaN(cuting.trim()) ? parseInt(cuting.trim()) : 0;
            console.log(idVehicle);
            this.errorMessage = `${this.items.find((v) => v.id === idVehicle).plate} ${this.t(
              'preassignment.formulario.tabla.errores.yaSeleccionado',
            )}`;
            this.showAlert();
            this.highlightedRow = 1;
            let position = this.items.findIndex((i) => i.id === idVehicle) + 1;
            let page = Math.trunc(position / this.perPage) + 1;
            this.currentPage = page;
          }
        }
      } else {
        this.launched = false;
      }
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    rowHighlighted(item, type) {
      if (!item || type !== 'row') return;
      if (item.id === this.highlightedRow) {
        return 'table-danger';
      }
    },
  },
  async mounted() {
    const rawVehicles = this.driver.vehicles.map((v) => v.id);
    this.selectedVehicle = rawVehicles.length ? rawVehicles[0] : null;
    this.$root.$on('bv::modal::hide', () => {
      setTimeout(() => {
        this.$destroy(); // cleanup in component
        this.$el.remove();
      }, 500);
    });
    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      preassignment: preassignmentEnUS,
    });
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      preassignment: preassignmentEsCL,
    });
    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      preassignment: preassignmentEsMX,
    });
    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      preassignment: preassignmentEsCO,
    });
  },
};
